import React from 'react';
import './StartedForm.scss';
import { closeStartedForm } from './taskSlice';


const StartedForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 const onSend = () => {
        
/*
    const item = {
        userId: props.user_id,
        imageName:props.avatar_name
    }
        console.log(item);
        */
      // dispatch(deleteAvatar(item));
      dispatch(closeStartedForm());
      props.handleStarted();
    }


    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeStartedForm());
    

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        const startText = "За выполненную задачу начисляются дополнительные баллы. Приступить к задаче?";
        const stopText = "Все начисленные за задачу баллы сгорят. Завершить задачу?";

      
            return(
                <div className="StartedForm">
                    
                <p><b> {!props.valueTask ? startText : stopText}</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
        
   
    }
return render();
}
export default StartedForm;
  